import WarmUpService from '@/bundles/WarmUp/services/WarmUpService';
import { http } from '@/bundles/Http/factory/HttpFactory';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';

function warmUpServiceFactory() {
  return new WarmUpService(http, new ErrorMapper());
}

export const warmUpService = warmUpServiceFactory();
